import React from 'react';
import { ArrowBack } from '@mui/icons-material';
import { Box, Button } from '@mui/material';

const ACCENT_GOLD = '#D8A363';

export const dashboardContentViewportHeight =
  'calc(100dvh - var(--fable-dashboard-modal-top, 0px))';

export const dashboardContentTopPadding = {
  xs: 5,
  sm: 4,
  md: 6,
} as const;

export const compactDashboardContentTopPadding = {
  xs: 3,
  md: 4,
} as const;

export const dashboardPageContainerSx = {
  pt: dashboardContentTopPadding,
  pb: 4,
} as const;

export const storyToolPageContainerSx = {
  pt: dashboardContentTopPadding,
  pb: 4,
  px: { xs: 2.5, sm: 4 },
} as const;

// FormPageActions reserves its own height and the final section gap.
export const storyToolFormPageContainerSx = {
  ...storyToolPageContainerSx,
  pb: 0,
} as const;

export const storyToolContentSx = {
  width: '100%',
  maxWidth: 1200,
  mx: 'auto',
} as const;

export const storyToolNarrowContentSx = {
  ...storyToolContentSx,
  maxWidth: { xs: '100%', md: 960, lg: 1040 },
} as const;

export const storyToolMediaContentSx = storyToolNarrowContentSx;

export const storyPreviewContentSx = {
  ...storyToolMediaContentSx,
  maxWidth: { xs: '100%', md: 900 },
} as const;

export const storyToolFormContentSx = {
  width: '100%',
  maxWidth: 600,
  mx: 'auto',
} as const;

// Matches the grouped sheet surface used by the mobile Account, Notifications,
// and Social Accounts screens.
export const settingsSheetCardSx = {
  bgcolor: 'rgba(255,255,255,0.05)',
  backgroundImage: 'none',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: 3,
  boxShadow: 'none',
  overflow: 'hidden',
} as const;

export const settingsSheetDividerSx = {
  borderColor: 'rgba(255,255,255,0.14)',
} as const;

export const storyPreviewDetailsContentSx = {
  ...storyPreviewContentSx,
  pt: 0,
  px: 0,
  mt: 0,
  textAlign: 'left',
} as const;

export const storyToolTitleSx = {
  color: '#FFFFFF',
  fontWeight: 800,
  mb: 0.75,
  fontSize: { xs: 36, md: 38, lg: 40 },
  lineHeight: 1.15,
  textAlign: 'left',
} as const;

export const storyToolSubtitleSx = {
  color: '#B9BAC5',
  fontSize: 16,
  textAlign: 'left',
} as const;

const backRowSx = {
  mb: 3,
  display: 'flex',
  justifyContent: 'space-between',
  gap: 2,
  minHeight: 40,
  alignItems: 'center',
} as const;

const backButtonSx = {
  color: ACCENT_GOLD,
  textTransform: 'none',
  fontSize: '1rem',
  borderRadius: '24px',
  px: 1.5,
  py: 1,
  minHeight: 40,
  '&:hover': {
    background: 'rgba(216, 163, 99, 0.1)',
  },
} as const;

interface SettingsBackButtonProps {
  endContent?: React.ReactNode;
  label?: string;
  onClick: () => void;
}

const SettingsBackButton: React.FC<SettingsBackButtonProps> = ({
  endContent,
  label = 'Back to Settings',
  onClick,
}) => (
  <Box sx={backRowSx}>
    <Button startIcon={<ArrowBack />} onClick={onClick} sx={backButtonSx}>
      {label}
    </Button>
    {endContent && (
      <Box sx={{ flexShrink: 0 }}>
        {endContent}
      </Box>
    )}
  </Box>
);

export default SettingsBackButton;
